import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import BeforeAfter from "@/components/BeforeAfter";
import Testimonials from "@/components/Testimonials";
import SocialMedia from "@/components/SocialMedia";
import FAQ from "@/components/FAQ";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import QuotePopup from "@/components/QuotePopup";
import AdminDashboard from "@/components/AdminDashboard";
import WindowCleaning from "@/pages/WindowCleaning";
import HouseWashing from "@/pages/HouseWashing";
import SurfaceCleaning from "@/pages/SurfaceCleaning";
import GutterCleaning from "@/pages/GutterCleaning";
import ShrinkWrapping from "@/pages/ShrinkWrapping";
import CommercialCleaning from "@/pages/CommercialCleaning";
import InteriorCleaning from "@/pages/InteriorCleaning";
import RequestQuotePage from "@/pages/RequestQuotePage";
import TownPage from "@/pages/TownPage";
import NassauCountyPage from "@/pages/NassauCountyPage";
import { initGA, trackPageView } from "@/utils/analytics";

const HomePage = () => {
  // Handle hash scrolling on page load
  React.useEffect(() => {
    if (window.location.hash === '#quote') {
      setTimeout(() => {
        const quoteSection = document.getElementById('quote');
        if (quoteSection) {
          quoteSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500);
    }
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <About />
      <BeforeAfter />
      <Testimonials />
      <SocialMedia />
      <FAQ />
      <QuoteForm />
      <Footer />
      <QuotePopup />
    </>
  );
};

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
    // Track initial page view
    trackPageView(window.location.pathname);
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/services/window-cleaning" element={<WindowCleaning />} />
          <Route path="/services/house-washing" element={<HouseWashing />} />
          <Route path="/services/surface-cleaning" element={<SurfaceCleaning />} />
          <Route path="/services/gutter-cleaning" element={<GutterCleaning />} />
          <Route path="/services/shrink-wrapping" element={<ShrinkWrapping />} />
          <Route path="/services/commercial-cleaning" element={<CommercialCleaning />} />
          <Route path="/services/interior-cleaning" element={<InteriorCleaning />} />
          <Route path="/request-a-quote" element={<RequestQuotePage />} />
          {/* Region hub pages */}
          <Route path="/nassau-county-ny" element={<NassauCountyPage />} />
          {/* Nassau County town-specific landing pages */}
          <Route path="/old-westbury-ny" element={<TownPage townSlug="old-westbury-ny" />} />
          <Route path="/brookville-ny" element={<TownPage townSlug="brookville-ny" />} />
          <Route path="/muttontown-ny" element={<TownPage townSlug="muttontown-ny" />} />
          <Route path="/sands-point-ny" element={<TownPage townSlug="sands-point-ny" />} />
          <Route path="/oyster-bay-cove-ny" element={<TownPage townSlug="oyster-bay-cove-ny" />} />
          <Route path="/plandome-ny" element={<TownPage townSlug="plandome-ny" />} />
          <Route path="/hewlett-bay-park-ny" element={<TownPage townSlug="hewlett-bay-park-ny" />} />
          {/* Hamptons town-specific landing pages for SEO */}
          <Route path="/locations/:town" element={<TownPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
